const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20girl%20avatar%20portrait%2C%20soft%20warm%20lighting%2C%20clean%20white%20background%2C%20minimal%20illustration%20style%2C%20friendly%20expression%2C%20simple%20design&width=120&height=120&seq=avatar-comment-01&orientation=squarish',
    name: '追漫小王子',
    time: '2小时前',
    content: '皮皮漫画的韩漫更新速度真的绝了！《秘密教学》刚出韩文版这边就同步上了，而且翻译质量超高，读起来完全没有生硬感。日漫分类也做得很好，找老番超级方便。',
    likes: 328,
    work: '在读《秘密教学》第72话',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20boy%20avatar%20portrait%2C%20soft%20warm%20lighting%2C%20clean%20white%20background%2C%20minimal%20illustration%20style%2C%20cool%20expression%2C%20simple%20design&width=120&height=120&seq=avatar-comment-02&orientation=squarish',
    name: '二次元老司机',
    time: '5小时前',
    content: '用了三年了，从一个韩漫平台换过来的。最满意的是国漫大图全彩模式，用iPad看简直不要太爽！《斗破苍穹》全彩版比黑白的有感觉多了，强烈推荐大家试试。',
    likes: 256,
    work: '在读《斗破苍穹》全彩版',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20girl%20avatar%20portrait%2C%20soft%20warm%20lighting%2C%20clean%20white%20background%2C%20minimal%20illustration%20style%2C%20happy%20expression%2C%20simple%20design&width=120&height=120&seq=avatar-comment-03&orientation=squarish',
    name: '樱花落',
    time: '8小时前',
    content: '日漫迷报道！咒术回战最新话这里的更新速度比我想象的快太多了，而且界面干净没广告，终于不用在各种弹窗里找下一页按钮了。已经安利给全宿舍的姐妹了！',
    likes: 189,
    work: '在读《咒术回战》第248话',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20boy%20avatar%20portrait%2C%20soft%20warm%20lighting%2C%20clean%20white%20background%2C%20minimal%20illustration%20style%2C%20smiling%20expression%2C%20simple%20design&width=120&height=120&seq=avatar-comment-04&orientation=squarish',
    name: '漫画重度患者',
    time: '12小时前',
    content: '排行榜功能太实用了，每周看韩漫排行榜就能发现新坑。之前追的几部完结了不知道看什么，刷了下热榜又找到好几部喜欢的。下拉阅读模式看韩漫竖屏超舒服。',
    likes: 412,
    work: '在读《女神降临》番外篇',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="font-heading text-xl md:text-3xl text-foreground-950 mb-3">
            读者热评
          </h2>
          <p className="text-sm text-foreground-500">漫画爱好者们的真实声音</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {comments.map((c, i) => (
            <div key={i} className="bg-background-50 rounded-xl p-5 md:p-6">
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img src={c.avatar} alt={c.name} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="font-semibold text-sm text-foreground-900">{c.name}</span>
                    <span className="text-xs text-foreground-400">{c.time}</span>
                  </div>
                  <p className="text-xs text-primary-500 mt-0.5">{c.work}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{c.content}</p>
              <div className="flex items-center gap-4 mt-3">
                <span className="inline-flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-thumb-up-line"></i> {c.likes}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}